<template>
  <div class="toggle-btn" 
    :style="{height: height+'px', width: width+'px'}"
    :class="[
        { 'active': toggledState },
        theme
    ]
    " 
    @click="$emit('changeState', !toggledState)"
  >
      <div 
      class="inner--circle" 
      :style="{
          height: innerHeight+'px', 
          width: innerWidth+'px', 
          left: toggleDirection == 'left' ? 
                    toggledState || toggledState == 1 ? 
                        (height - innerHeight)/2 + 'px' 
                        : 'calc(100% - '+((height - innerHeight)/2+innerWidth) + 'px)' 
                : '',
            right: toggleDirection == 'right' ? 
                    toggledState || toggledState == 1 ? 
                        (height - innerHeight)/2 + 'px' 
                        : 'calc(100% - '+((height - innerHeight)/2+innerWidth) + 'px)' 
            : '',

        }"
      >
        <svg v-if="theme == 'search' && toggledState && !loading" width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.2107 1.61816L6.75225 11.7214C6.66116 11.8097 6.55292 11.8798 6.43375 11.9276C6.31457 11.9754 6.18679 12 6.05775 12C5.9287 12 5.80093 11.9754 5.68175 11.9276C5.56257 11.8798 5.45433 11.8097 5.36324 11.7214L0.787674 7.30124C0.69647 7.21313 0.624123 7.10854 0.574764 6.99342C0.525405 6.8783 0.5 6.75492 0.5 6.63032C0.5 6.50572 0.525405 6.38234 0.574764 6.26722C0.624123 6.15211 0.69647 6.04751 0.787674 5.9594C0.878877 5.8713 0.987152 5.80141 1.10632 5.75372C1.22548 5.70604 1.3532 5.6815 1.48218 5.6815C1.61116 5.6815 1.73888 5.70604 1.85804 5.75372C1.97721 5.80141 2.08548 5.8713 2.17669 5.9594L6.05856 9.70944L15.8233 0.277904C16.0075 0.0999648 16.2573 0 16.5178 0C16.7783 0 17.0281 0.0999648 17.2123 0.277904C17.3965 0.455842 17.5 0.697179 17.5 0.948823C17.5 1.20047 17.3965 1.4418 17.2123 1.61974L17.2107 1.61816Z" fill="white"/>
        </svg>
        <font-awesome-icon icon="spinner" v-if="loading" />
      </div>
  </div>
</template>

<script>
export default {
    props:{
        toggledState:{
            type: [Boolean, Number],
            default: false
        },
        loading:{
            type: Boolean,
            default: false
        },
        height:{
            type: Number,
            default: 36
        },
        width:{
            type: Number,
            default: 72,
        },
        innerHeight:{
            type: Number,
            default: 30
        },
        innerWidth:{
            type: Number,
            default: 30
        },
        toggleDirection:{
            type: String,
            default: 'left'
        },
        theme:{
            type: String,
            default: 'white'
        }
    },
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.toggle-btn{
    position: relative;
    display: flex;
    border-radius: 3rem;
    background: white;
    cursor: pointer;
    overflow: hidden;
    &.gray{
        background: #efefef;
        .inner--circle{
            background: white;
        }
    }
    &.active{
        background: var(--secondary-color);
        .inner--circle{
            background: white;
        }
    }
    &.bidirectional{
        background: #fff;
        .inner--circle{
            background: var(--secondary-color);
        }
        &.active{
            background: #fff;
            .inner--circle{
                background: var(--secondary-color);
            }
        }
    }
    &.search{
        background: #fff;
        box-shadow: 0 0 4px 0 rgba(96, 96, 96, 0.25);
        .inner--circle{
            display: flex;
            align-items: center;
            justify-content: center;
            background: #D5D5D5;
        }
    
        &.active{
            background: #fff;
            .inner--circle{
                background: #4D4D4D;
            }
        
        }
        svg{
            animation: fade 1s;
        }
        
    }
    &.mobile-active{
        background: #efefef;
        .inner--circle{
            background: var(--secondary-color);
        }
        &.active{
            background: #CACACA;
            .inner--circle{
                background: var(--secondary-color);
            }
        }
    }

}

.inner--circle{

    position: absolute;
    background: #efefef;
    top: 0;
    bottom: 0;
    margin: auto;
    border-radius: 50%;
     transition: left 0.3s, right 0.3s;

}
@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>